const featureToggles = {
  savedJobs: true,
  uploadCV: true,
  creatorPartnership: true,
  // Allow-list of user IDs who see gated features (e.g. Cello on production).
  featureFlagOverrideUserIds: [2, 341236],
};

/**
 * Cello referral UI: shown in non-production Twine environments (`__CLOUD_ENV__` !== `production`)
 * for any logged-in user; on production, only for IDs in `featureFlagOverrideUserIds`.
 * (`__CLOUD_ENV__` from webpack — see scripts/utils `getCloudEnv`.)
 *
 * @param {{ id?: number|string }} [user]
 * @returns {boolean}
 */
export function showCelloReferralForUser(user) {
  if (!user || user.id == null) {
    return false;
  }
  if (__CLOUD_ENV__ !== 'production') {
    return true;
  }
  return featureToggles.featureFlagOverrideUserIds.some((x) => Number(x) === Number(user.id));
}

export default featureToggles;
